/**
 * BroadcastActions — кнопки действий для рассылки
 * Дата: 26.02.2026 — PLAN Manual Broadcasts
 */
import { Play, Square, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui';
import { BroadcastStatusBadge } from './BroadcastStatusBadge';
import type { ManualBroadcast } from '@/api/manualBroadcasts';

interface BroadcastActionsProps {
  broadcast: ManualBroadcast;
  onLaunch: (id: string) => void;
  onCancel: (id: string) => void;
  onDelete: (id: string) => void;
  canWrite: boolean;
  launchBlocked?: boolean;
  loading?: boolean;
}

export function BroadcastActions({
  broadcast,
  onLaunch,
  onCancel,
  onDelete,
  canWrite,
  launchBlocked = false,
  loading = false,
}: BroadcastActionsProps) {
  const canLaunch = broadcast.status === 'draft' && canWrite;
  const canCancel = (broadcast.status === 'running' || broadcast.status === 'paused') && canWrite;
  const canDelete = broadcast.status === 'draft' && canWrite;

  return (
    <div className="flex items-center gap-2">
      <BroadcastStatusBadge status={broadcast.status} />
      {canLaunch && (
        <Button
          variant="primary"
          size="sm"
          onClick={() => onLaunch(broadcast.id)}
          disabled={loading || launchBlocked}
          title={launchBlocked ? 'Запуск этой рассылки временно заблокирован суперадмином' : 'Запустить'}
        >
          <Play className="w-4 h-4 mr-1" /> Запустить
        </Button>
      )}
      {canCancel && (
        <Button variant="secondary" size="sm" onClick={() => onCancel(broadcast.id)} disabled={loading} title="Отменить">
          <Square className="w-4 h-4 mr-1" /> Отменить
        </Button>
      )}
      {canDelete && (
        <Button variant="ghost" size="sm" onClick={() => onDelete(broadcast.id)} disabled={loading} title="Удалить">
          <Trash2 className="w-4 h-4 mr-1" /> Удалить
        </Button>
      )}
    </div>
  );
}
